import React from 'react';
import { Styled } from './';
import { RentalOrderDetailsProps } from 'components/ITeroProposal/ITeroProposal.types';
import { useI18n } from 'contexts/i18n';

const RentalOrderDetails = ({ currentProposal }: RentalOrderDetailsProps) => {
  const i18n = useI18n();
  return (
    <Styled.Proposal $rental>
      <Styled.Head data-testid="rental-order-details-head">
        <Styled.HeaderCell>{i18n['Product(s)']}</Styled.HeaderCell>
        <Styled.HeaderCell>{i18n['Quantity']}</Styled.HeaderCell>
        <Styled.HeaderCell>{i18n['Selling Term (No. of months)']}</Styled.HeaderCell>
        <Styled.HeaderCell>{i18n['Rental List Price']}</Styled.HeaderCell>
        <Styled.HeaderCell>{i18n['Total Promotions/Discounts']}</Styled.HeaderCell>
        <Styled.HeaderCell>{i18n['Rental Price/Per month']}</Styled.HeaderCell>
        <Styled.HeaderCell>{i18n['Total Rental Price']}</Styled.HeaderCell>
      </Styled.Head>
      <Styled.BodyRows data-testid="rental-order-details-body">
        {currentProposal.lineitems.map(item => (
          <React.Fragment key={item.description}>
            <Styled.BodyCell>
              <Styled.BodyCellContent>
                <div>{item.description}</div>
                {item.softwareType && (
                  <Styled.SubOptions>
                    <strong>{i18n['Software Type']}</strong> {item.softwareType}
                  </Styled.SubOptions>
                )}
              </Styled.BodyCellContent>
            </Styled.BodyCell>
            <Styled.BodyCell>{item.itemSequence}</Styled.BodyCell>
            <Styled.BodyCell>{item.sellingTerm}</Styled.BodyCell>
            <Styled.BodyCell>{item.displayItemUnitPrice}</Styled.BodyCell>
            <Styled.BodyCell>
              {item.promotion?.amount}
              <br />
              {item.promotion?.programName}
              {item.promotion?.programCode &&
                `(${item.promotion?.programCode})`}
            </Styled.BodyCell>
            <Styled.BodyCell>{item.netUnitPrice}</Styled.BodyCell>
            <Styled.BodyCell $noWrap>
              {item.displayItemTotal}
              {item.promotion?.amount && (
                <Styled.Discount>
                  <br />( {item.promotion?.amount} Off )
                </Styled.Discount>
              )}
            </Styled.BodyCell>
          </React.Fragment>
        ))}
      </Styled.BodyRows>
    </Styled.Proposal>
  );
};

export default RentalOrderDetails;
